import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import ProductSelector from "./ProductSelector";
import "../assets/stylesheets/Home.scss";

@inject('Navigator', 'ConfigStore', 'SchoolStore', 'ProductStore')
@observer
export default class Home extends Component {

    componentDidMount(){
    }

    goToEboard(e){
        this.props.ConfigStore.animationType = 'left';
        this.props.Navigator.push('/eboard');
    }

    render() {
        const { ProductStore } = this.props;

        if (ProductStore.isProductSelectorVisible && !ProductStore.selectedProduct) {
            return (
                <div className="Page ProductSelectorPage">
                    <ProductSelector />
                </div>
            );
        }

        return (
            <div className="Home Page">
                <div className="container">
                    <div className="text">
                        <p className="title">BEM VINDO AO</p>
                        <h1>Portal do Professor</h1>
                        <p className="description">Utilize as funcionalidades do menu para se preparar para </p>
                        <p className="description">a aula
                        ou acesse os <span>materiais</span> clicando no botão abaixo:</p>
                        <div className="btn-container">
                            <button className="btn"
                                    onClick={this.goToEboard.bind(this)}>
                                Materiais
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/Home.js